import { render, staticRenderFns } from "./CardExclusive.vue?vue&type=template&id=021de2ec&scoped=true&"
import script from "./CardExclusive.vue?vue&type=script&lang=js&"
export * from "./CardExclusive.vue?vue&type=script&lang=js&"
import style1 from "./CardExclusive.vue?vue&type=style&index=1&id=021de2ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021de2ec",
  null
  
)

export default component.exports